<template>
    <v-container v-if="question.answers">
        <v-row>
            <v-col cols="10" sm="11">
                <h1>{{ question.title }}</h1>
            </v-col>
            <v-col cols="2" sm="1" class="text-right">
                <v-progress-circular
                    :value="progress"
                    color="lightBlue"
                    size="30"
                    class="msc-rating mt-4"
                ></v-progress-circular>
            </v-col>
        </v-row>
        <h2>{{ question.description }}</h2>
        <div class="current">{{ slider.text }}</div>
        <v-slider
            height="50"
            :tick-labels="slider.labels"
            :min="slider.min"
            :max="slider.max"
            ticks="always"
            tick-size="3"
            v-model="answer"
            @change="updateText"
            track-color="primary"
            track-fill-color="secondary"
        ></v-slider>
        <v-btn v-if="!isFirstPage()" @click="prev">Prev</v-btn>
        <v-btn v-if="!isLastPage()" color="primary" @click="next()">
            Next
        </v-btn>
        <v-btn v-if="isLastPage()" @click="last" color="primary">
            Finish
        </v-btn>
    </v-container>
</template>

<script>
import Questions from '../data/questions';
import questionService from '../services/QuestionService';
import paginationService from '../services/Pagination';

export default {
    name: 'Questions',
    data: () => ({
        questions: Questions,
        question: Object,
        answer: 1,
        slider: {
            min: 1,
            max: 5,
            labels: [],
            text: '',
        },
    }),
    created() {
        this.$store.dispatch('loadFromSession');
        this.question = questionService.find(this.questions, this.pageId);

        let ans = this.question.answers;
        let labels = [];
        this.slider.max = ans.length;

        for (let i = 0; i < ans.length; i++) {
            labels[i] = ans[i].label;
        }

        this.slider.labels = labels.reverse();
        this.updateText();
    },
    methods: {
        createOrUpdateAnswer() {
            this.$store.commit('createOrUpdateAnswer', {
                id: this.pageId,
                answer: this.answer,
                method: this.question.method,
            });
        },
        updateText() {
            this.slider.text = this.question.answers[
                Math.abs(this.answer - this.question.answers.length)
            ].description;
        },
        next() {
            this.createOrUpdateAnswer();
            this.$router.push({
                path: `/question/${paginationService.nextPage(this.pageId)}`,
            });
        },
        prev() {
            this.createOrUpdateAnswer();
            this.$router.push({
                path: `/question/${paginationService.prevPage(this.pageId)}`,
            });
        },

        last() {
            this.createOrUpdateAnswer();
            this.$router.push('/results');
        },

        isFirstPage() {
            return paginationService.isFirstPage(this.pageId);
        },
        isLastPage() {
            return paginationService.isLastPage(
                this.pageId,
                this.questions.length
            );
        },
    },
    computed: {
        pageId() {
            return parseInt(this.$route.params.id);
        },

        progress() {
            return (this.pageId / this.questions.length) * 100;
        },
    },
};
</script>
<style lang="scss">
.v-slider {
    cursor: pointer !important;
}
</style>
